<template>
    <div class="fixedDitch">
        <div class="resource-search">
            <div class="search-resource flex flex-mid" v-for="(item,index) in searchData" :key="index">
                <p>{{item.name}}</p>
                <div class="search-resource-input">
                    <input type="text" v-model="item.value" :placeholder="'请输入'+item.name">
                </div>
            </div>
            <div class="search-submit">
                <a href="javascript:" @click="submitBtn">查询</a>
            </div>
            <div class="add-link">
                <a href="javascript:" @click="changeShow">
                    <i class="iconfont icon-jia"></i>
                    <span>新增</span>
                </a>
            </div>
        </div>
        <div class="table-box">
            <table border="0">
                <tr class="table-title">
                    <td v-for="(item,index) in searchTitle" :key="index">{{item.name}}</td>
                    <td>操作</td>
                </tr>
                <tr v-for="(item,index) in pageArr" :key="index">
                    <td>{{item.type}}</td>
                    <td>{{item.name}}</td>
                    <td v-if="item.web_desc" v-html="item.web_desc">{{item.web_desc}}</td>
                    <td>{{item.identifying}}</td>
                    <td  v-if="item.pattern">{{item.pattern}}</td>
                    <td class="td-edit">
                        <a class="table-edit" v-if="item.web != 1" href="javascript:" @click="bindEdit($event,item.id)">编辑</a>
                        <a class="table-remove" v-if="item.web != 1" href="javascript:" @click="bindRemove($event,item.id)">删除</a>
                    </td>
                </tr>
            </table>
            <div class="list-hint" v-show="isShowTip" @click="isShowTip = false">
                <div class="list-hint-box" @click.stop>
                    <p class="p1">确认{{tip}}</p>
                    <p class="p2">
                        <a href="javascript:" @click="bindConfirm">确定</a>
                        <a href="javascript:" @click="isShowTip = false">取消</a>
                    </p>
                </div>
            </div>
        </div>
        <page @switchPage="bindSetPage" :pagesize="pageSize" :total="total" :isQuery="isQuery"></page>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import  bus from './js/a.js';
    import page from "./page"
    export default {
        name:"fixedDitch",
        props:['searchData','searchTitle','searchUrl',"busName",'refresh','isAjax'],
        data(){
            return {
                arr:0,
                // 当前页面数据
                pageArr:[],
                tip:"",
                isShowTip:false,
                isRemove:false,
                dataId:0,
                pageSize:0,
                total:0,
                isQuery:0,
                isDelete:false
            }
        },
        watch:{
            'refresh':function(){
                this.submitData({name:'',identifying:'',page:1});
            },
            "isAjax":function(){
                 this.submitData({name:'',identifying:'',page:1});
                ++this.isQuery;
            }
        },
        mounted(){
            document.body.addEventListener("click",()=>{
                this.isSelect = this.isDitch = false;
            })
            this.submitData({name:'',identifying:'',page:1})
        },
        methods:{
            ...mapActions(['setHint']),
            // 查询
            submitData(data){
                let _data = data;
                let _this = this;
                if(localStorage.getItem("token")){
                    $.ajax({
                        url:_this.searchUrl+'getData',
                        headers: {
                            'Auth-Token' : localStorage.getItem("token")
                        },
                        type:"POST",
                        data:_data,
                        dataType:"JSON",
                        success:function(res){
                            _this.pageArr = res.data.list;
                            _this.arr = res.data.total;
                            _this.pageSize = res.data.pageSize;
                            _this.total = res.data.total;
                        }
                    })
                }else{
                    this.$router.push({path:"/"})
                }
            },
            // 查询数据
            submitBtn(){
                this.submitData({name:this.searchData[0].value,identifying:this.searchData[1].value,page:1})
                ++this.isQuery;
            },
            // 父组件通信(跳转到新增页面)
            changeShow(){
                bus.$emit("bindEmpty")
                this.$emit('bindBrother',false)
                this.$emit("getChild")
            },
            // 编辑按钮
            bindEdit(event,id){
                this.$emit('bindBrother',id)
                this.$emit("getChild")
                // this.$emit("bindChildEdit",{id:id,isEdit:++this.isEdit})
               
            },
            // 删除按钮
            bindRemove(event,id){
                this.tip = "删除";
                this.isShowTip = true;
                this.dataId = id;
            },
            // 确定操作
            bindConfirm(event,id){
                let _this = this;
                if(localStorage.getItem("token")){
                    $.ajax({
                        url:_this.searchUrl+"delete",
                        headers: {
                            'Auth-Token' : localStorage.getItem("token")
                        },
                        type:"POST",
                        data:{id:this.dataId},
                        dataType:"JSON",
                        success:(res)=>{
                            this.isShowTip = false;
                            if(res.status == 1){
                                // 删除是 会改变page值 使其再加载一次 这里用一个bl值 使其在删除是 page的加载无效
                                this.isDelete = true;
                                setTimeout(()=>{
                                    this.isDelete = false
                                },1000)
                                // 
                                this.setHint({txt:res.msg,className:"hint-success"});
                                ++this.isQuery;
                                this.submitData({name:'',identifying:'',page:1});
                                $('.admin-main-right').animate({scrollTop: 0},1);
                            }else{
                                this.setHint({txt:res.msg,className:"hint-error"})
                            }
                        }
                    })
                }
                else{
                    this.$router.push({path:"/"})
                }
            },
            bindSetPage(val){
                if(!this.isDelete){
                    this.submitData({name:this.searchData[0].value,identifying:this.searchData[1].value,page:val})
                }
            }
        },
        components:{
            page:page
        }
    }
</script>

<style scoped>
/*搜索栏*/
.resource-search {
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    font-size: 14px;
    color: #333;
    text-align: left;
    
}
/*模拟select*/
.search-resource {
    padding: 6px 12px;
    width: 38%;
}
.search-resource-input {
    position: relative;
    margin: 0 14px;
    width: 65%;
}
.search-resource-input input{
    position: relative;
    display: flex;
    align-content: center;
    width: 100%;
    height: 36px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px #e4e4e4 solid;
    border-radius: 3px;   
    cursor: pointer;
}
/*筛选提交按钮*/
.search-submit,
.add-link {
    padding: 6px 12px;
    width: 12%;
}
.search-submit a,
.add-link a{
    display: block;
    width: 100%;
    line-height: 36px;
    border-radius: 3px;
    background-color: #ffcc00;
    text-align: center;
    color: #fff;
    font-size: 16px;
}
.add-link a{
    background-color: #70ca10;
}
/*table 表单*/ 
.table-box {
    width: 100%;
    /* min-height: 590px; */
    border-bottom: 1px #f7f7f7 solid;
    margin: 20px 0;
}
table {
    text-align: left;
    width: 100%;
    color: #333;
    border-collapse:collapse;
}

tr {
    font-size:14px; 
}
tr:nth-child(odd){
    background-color: #f7f7f7;
}
tr td {
    padding: 20px 30px;
}
.table-title {
    font-size: 16px;
    font-weight: bold;
}
.td-edit {
    display: flex;
    justify-content: space-between;
}
.table-edit {
    color:#00BFFF;
}
.table-remove {
    color:red;
}
</style>




// WEBPACK FOOTER //
// src/components/main/ditchlist.vue